import { Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { SettingsItem } from "Components/Settings/SettingsItem/SettingsItem";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useMenuLinks } from "Hooks/Layout/useMenuLinks";
import { Resources, useResource } from "Translations/Resources";

export const CustomerOnboardingDashboardPage = () => {
  const { t } = useResource();
  const { toBeVerified, merchants, hunters, campaigns, users } = useMenuLinks();

  const quickLinks = [users, merchants, hunters, toBeVerified, campaigns];

  return (
    <AuthenticatedLayout title={t(Resources.Pages.Titles.Dashboard)}>
      <StyledPageWrapper>
        <Stack className="left-content">
          {quickLinks.map((link) => (
            <SettingsItem link={link} key={link.text} />
          ))}
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default CustomerOnboardingDashboardPage;
